export default "\r\n    \r\n    <div class=\"row bg-blue-800\" style=\"height:60vh;\">\r\n        <canvas [id]=\"nameChart\"></canvas>\r\n    </div>\r\n";